var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.103 3.643c1.28-2.243 4.514-2.243 5.794 0l7.66 13.404c1.27 2.225-.336 4.993-2.898 4.993H4.341c-2.563 0-4.17-2.769-2.897-4.993zm4.058.992a1.336 1.336 0 0 0-2.322 0L3.18 18.04c-.51.892.134 2.001 1.161 2.001h15.318c1.026 0 1.67-1.11 1.16-2zm-1.162 10.49.128.006a1.25 1.25 0 1 1-.256 0l.128-.006zM12 8.38a1 1 0 0 1 .993.883L13 9.38v3.74a1 1 0 0 1-1.993.117L11 13.12V9.38a1 1 0 0 1 1-1z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarning);
export default __webpack_public_path__ + "static/media/icons-warning.39ac1e326857e39ab1240c5d729d85c2.svg";
export { ForwardRef as ReactComponent };